import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { planSettingsPath } from "@circle-react/helpers/urlHelpers";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";
import { useLocation, useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { usePlanTrialBanner } from "@/react/components/Layout/TrialBanner/usePlanTrialBanner";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";

export const PlanTrialOffer = () => {
  const {
    isPlanTrialActive,
    planTrialDaysLeft,
    planTrialEndDateFormatted,
    planTrialExpiringInTimer,
    planTrial,
  } = usePlanTrialBanner();
  const { trackEvent } = useEventsTracker();
  const { isCircleV4 } = useCircleV4();
  const navigate = useNavigate();
  const pathname = useLocation({ select: location => location.pathname });

  if (!isPlanTrialActive) {
    return null;
  }

  const isOnPlansPage = pathname === planSettingsPath();

  const handleOnClick = () => {
    trackEvent("trial_banner.layout.manage_plan.clicked", {
      days_left: planTrialDaysLeft,
      is_plan_trial: true,
      trial_type: planTrial?.trial_type,
    });
    void navigate({ to: planSettingsPath() });
  };

  if (isCircleV4) {
    return (
      <Banner
        variant="warning"
        icon="clock"
        iconColor="warning"
        title={t("plan_trial_banner.business_trial_ends_in_days", {
          days: planTrialDaysLeft,
        })}
        description={
          planTrialExpiringInTimer
            ? t("plan_trial_banner.renews", {
                formatted_date: planTrialEndDateFormatted,
                action: t("plan_trial_banner.cancel_anytime"),
              })
            : undefined
        }
        actionProps={
          isOnPlansPage
            ? undefined
            : {
                variant: "outline",
                children: t("plan_trial_banner.manage_plan"),
                onClick: handleOnClick,
              }
        }
      />
    );
  }

  return (
    <div>
      <div className="text-darkest flex items-center gap-2">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm weight="font-semibold" size="text-md">
          {t("plan_trial_banner.business_trial_ends_in_days", {
            days: planTrialDaysLeft,
          })}
        </Typography.BodySm>
        {planTrialExpiringInTimer && (
          <>
            <span className="text-darkest">
              {t("plan_trial_banner.separator")}
            </span>
            <Typography.BodySm weight="font-normal" size="text-md">
              {t("plan_trial_banner.renews", {
                formatted_date: planTrialEndDateFormatted,
                action: t("plan_trial_banner.cancel_anytime"),
              })}
            </Typography.BodySm>
          </>
        )}

        {!isOnPlansPage && (
          <Button
            className="ml-1 text-md font-semibold"
            variant="circle"
            onClick={handleOnClick}
          >
            {t("plan_trial_banner.manage_plan")}
          </Button>
        )}
      </div>
    </div>
  );
};
